import { ChakraFlex } from '@equip.health/ui';

import Attendee from './Attendee';

interface AttendeeListProps {
  attendees: GroupClassEventAttendeeExtended[];
}

const AttendeeList = ({ attendees }: AttendeeListProps) => {
  return (
    <ChakraFlex flexDirection="column" width="50%">
      {(attendees ?? []).map((attendee: GroupClassEventAttendeeExtended) => (
        <Attendee attendee={attendee} key={attendee.externalId} />
      ))}
    </ChakraFlex>
  );
};

export default AttendeeList;
